const showButton = () => {
  var $ = jQuery;
  var x = 7;
  var size = $('.card-item').length;
  $('.card-item:not(".no-data-link"):gt(' + x + ')').hide();

  $('.show-cards').click(function (e) {
    e.preventDefault();

    x = (x + 8 <= size) ? x + 8 : size;
    if (x === size) {
      $(this).hide();
    }
    $('.card-item:not(".no-data-link"):lt(' + x + ')').fadeIn();
  });

  $('.show-cards').parent().css({'clear': 'both'});
};

export { showButton };

const loadMore = (visible) => {
  $('.show-more-widget').each(function () {
    $(this).find('.card-item:lt(' + visible + ')').show();
    var cardLength = $(this).find('.card-item').length;
    if (cardLength > 8) {
      $(this).find('.show-more-wrapper').removeClass('hide');
      $(this).find('.show-more').show();
    }
  });
  // $('#showLess').hide();
  $('.show-more').click(function (e) {
    e.preventDefault();
    var items = $(this).parents('.show-more-widget').find('.card-item').length;
    // $('#showLess').show();
    var shown = $(this).parents('.show-more-widget').find('.card-item:visible').length + 8;
    if (shown < items) {
      console.log('test');
      $(this).parents('.show-more-widget').find('.card-item:lt(' + shown + ')').fadeIn();
    } else {
      $(this).parents('.show-more-widget').find('.card-item:lt(' + items + ')').fadeIn();
      $(this).hide();
      $(this).parent('.show-more-wrapper').addClass('hide');
    }
  });
  // $('.less-more').click(function () {
  //   $(this).parents('.show-more-widget').find('.card-item').not(':lt(3)').fadeOut();
  // });
};

export { loadMore };
